<template>
    <div class="campaign-option">
        <div class="campaign-option--title">
            Creative
            <info-tooltip text="Select the creative you wish to apply to this ad set. These can be setup for you by customer service."></info-tooltip>
        </div>

        <div class="campaign-adset-location__input">
            <multiselect
                v-model="creative"
                :multiple="false"
                :options="creatives"
                label="name"
                :close-on-select="true"
                :hide-selected="false"
                track-by="uuid"
                :placeholder="placeholder"
                :deselect-label="'Remove this creative'"
                :show-labels="true">
            </multiselect>
        </div>

        <div v-if="creative" class="creative-container">
            <div class="creative-title" v-if="creative.description">Description</div>
            <div v-html="descriptionHtml"></div>
            <template v-if="creative.hours_of_operation">
                <div class="creative-title">Hours Of Operation</div>
                <div v-html="hoursHtml"></div>
            </template>
            <div class="creative-title" v-if="creative.landing_url">Landing Url</div>
            <div style="overflow-wrap: break-word;">
                <a :href="creative.landing_url" target="_blank">{{ creative.landing_url }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: { Multiselect },

        props: {
            value: String,
            creatives: Array
        },

        data() {
            return {
                creative: null,
                placeholder: 'Select a creative',
                description: '',
                hoursOfOperation: ''
            }
        },

        watch: {
            creative() {
                var uuid = (this.creative && this.creative.uuid) ? this.creative.uuid : null;
                this.$emit('input', uuid);
            }
        },

        computed: {
            descriptionHtml() {
                return this.creative.description;
            },

            hoursHtml() {
                return this.creative.hours_of_operation;
            }
        },

        methods: {
            defaultCreative() {
                if (this.creatives && this.value && this.creatives.length > 0 && this.value.length > 0) {
                    var defaultUuid = this.value;
                    this.creative = _.find(this.creatives, function (item) {
                        return item.uuid == defaultUuid;
                    });
                }
            }
        },

        mounted() {
            this.defaultCreative();
        }
    }
</script>

<style>
    .creative-container {
        border: 1px solid #eeeeee;
        padding: 0 15px 20px 15px;
        margin-top: 15px;
    }

    .creative-title {
        font-size: 20px;
        font-weight: bold;
        margin: 15px 0 4px 0;
    }
</style>
